import { render, staticRenderFns } from "./Vidjet-radio-btn.vue?vue&type=template&id=0bd5ee8f&scoped=true&"
import script from "./Vidjet-radio-btn.vue?vue&type=script&lang=js&"
export * from "./Vidjet-radio-btn.vue?vue&type=script&lang=js&"
import style0 from "./Vidjet-radio-btn.vue?vue&type=style&index=0&id=0bd5ee8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5ee8f",
  null
  
)

export default component.exports